import { mapState } from "vuex";

const mixin = {
    computed: {
        ...mapState({
            currentTemplates: (state) => state.currentTemplates,
        })
    }
}

export default mixin;